<template>
    <div>
        <div>
            <b-card v-show="mostrarTabela" no-body>
                <b-card-body>
                    <h4 class="heading-1 mb-4">
                        <span>FILIAIS</span>
                        <div class="float-right">
                            <span class="text-primary">
                                <i
                                    class="fa fa-refresh fa-lg icon-button"
                                    title="Atualizar"
                                    @click.stop="obterFiliais()"
                                ></i>
                            </span>
                        </div>
                    </h4>
                    <app-tabela
                        idTabela="tblFiliais"
                        :itens="filiais"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false"
                    >
                        <template slot="botoes">
                            <btn-inserir></btn-inserir>
                        </template>
                        <template slot="acoes" slot-scope="data">
                            <btn-atualizar
                                :filialId="data.filialId"
                            ></btn-atualizar>
                            <btn-excluir
                                :filial="data"
                                @obterFiliais="obterFiliais()"
                            ></btn-excluir>
                        </template>
                    </app-tabela>
                </b-card-body>
            </b-card>
        </div>
        <router-view
            @obterFiliais="obterFiliais()"
        ></router-view>
    </div>
</template>

<script>
import FiliaisServicos from './FiliaisServicos';
import BtnExcluir from './BtnExcluir.vue';
import BtnInserir from './BtnInserir.vue';
import BtnAtualizar from './BtnAtualizar.vue';

export default {
    components: {
        BtnExcluir,
        BtnInserir,
        BtnAtualizar
    },
    
    data() {
        return {
            filiais: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'nomeFornecedor',
                    label: 'Filial'
                },
                {
                    key: 'cnpjCpfFilial',
                    label: 'CNPJ/CPF da filial'
                },
                {
                    key: 'cnpjCpfMatriz',
                    label: 'CNPJ/CPF da matriz'
                },
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        obterFiliais() {
            this.$store.dispatch('addRequest')
            FiliaisServicos.obterTodos().then(response => {
                if (response) {
                    if (response.success) {
                        this.filiais = response.data
                    } else {
                        this.$toast.error(
                            'Não foi possivel obter as filiais',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })

        }
    },

    created() {
        this.obterFiliais()
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === 'Filiais'
        }
    },
}

</script>